import { render } from "./HospitalHome.vue?vue&type=template&id=c8ea05e2&scoped=true"
import script from "./HospitalHome.vue?vue&type=script&lang=js"
export * from "./HospitalHome.vue?vue&type=script&lang=js"

import "./HospitalHome.vue?vue&type=style&index=0&id=c8ea05e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8ea05e2"]])

export default __exports__